// extracted by mini-css-extract-plugin
module.exports = {"shadow":"HelpInfo_shadow__JXtBJ","appInfo":"HelpInfo_appInfo__1N8jr","title":"HelpInfo_title__3BAj1","value":"HelpInfo_value__1FrrT"};